import { ValueOf } from '@/types/util';

export const transactionStatus = {
  SUCCESS: '取引成功',
  CANCELED: '取消',
  FAILURE: '取引失敗',
  WAITING_AUTH: '3Dセキュア認証待ち',
} as const;

export type TransactionStatusKey = keyof typeof transactionStatus;
export type TransactionStatusValue = ValueOf<typeof transactionStatus>;

export const transactionStatusKeys = Object.keys(transactionStatus) as TransactionStatusKey[];

/** v-select用items */
export const transactionStatusItems = transactionStatusKeys
  .map((key) => ({
    title: transactionStatus[key],
    value: key,
  }));
